import { Texture } from './Texture'
import { BaseRenderer } from './BaseRenderer'

import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase'
gsap.registerPlugin(CustomEase);

export class FocusPointsRevealer extends BaseRenderer {
    constructor($parentBlock) {
        super()
        this.$parentBlock = $parentBlock
        this.focusPoints = {}
        
        this.registerFocusPoint('idle', 0.5, 0.5, 1)
        
        this.$img = this.$canvas.querySelector('img')
        this.imgAspectRatio = this.$img.naturalWidth / this.$img.naturalHeight
        this.texture = new Texture(this.$img)
        
        const [image, dx, dy, dWidth, dHeight] = this.computeDrawImageParams('idle')
        this.drawImageParams = {
            current: {dx, dy, dWidth, dHeight},
            final: undefined
        }
        
        this.$wrapper.addEventListener('canvas:resize', () => {
            const finalFocusPointName = this.$parentBlock.expandygg.modalManager.currentID
            const currentParams = this.computeDrawImageParams(finalFocusPointName)
            // console.log('heard canvas:resize ! new params are:', currentParams)
            this.drawImageParams.current = {
                dx: currentParams[1],
                dy: currentParams[2],
                dWidth: currentParams[3],
                dHeight: currentParams[4]
            }
            this.render()
        }, {capture: false, passive: true, once: false} || false)
    }
    registerFocusPointsBySelector(selector) {
        document.body.querySelectorAll(selector).forEach(_$point => {
            this.registerDOMFocusPoint(_$point)
        })
    }
    registerFocusPoint(name, x, y, zoomFactor) {
        this.focusPoints[name] = {x, y, zoomFactor}
    }
    registerDOMFocusPoint($focusPoint) {
        this.focusPoints[$focusPoint.dataset.name] = {
            x: parseFloat($focusPoint.dataset.x), 
            y: parseFloat($focusPoint.dataset.y), 
            zoomFactor: parseFloat($focusPoint.dataset.zoomFactor)
        }
    }
    focus(focusPointName) {
        this.nextFocusPoint = focusPointName
        const params = this.computeDrawImageParams(focusPointName)
        this.drawImageParams.final = params
        // console.log(this.drawImageParams.final)
        
        // this.drawImageParams.current = params // temp
        
        // this.render()
        this.triggerTweening()
    }
    whereToDisplayTheFocusPoint(focusPointName) {
        // temp // debug
        // return {
        //     x: 0.5,
        //     y: 0.5
        // }
        
        if (focusPointName === 'idle') {
            return {
                x: 0.5,
                y: 0.5
            }
        }
        
        const $modal = this.$parentBlock.expandygg.modalManager.$container
        const isMobile = window.innerWidth < 768
        if (isMobile) {
            return {
                x: 0.5,
                y: (window.innerHeight - $modal.offsetHeight) / 2 / this.$canvas.height
            }
        } else {
            // console.log('window.innerWidth', window.innerWidth)
            // console.log('$modal.offsetWidth', $modal.offsetWidth)
            return {
                x: (window.innerWidth - $modal.offsetWidth) / 2 / this.$canvas.width,
                y: (window.innerHeight - $modal.offsetHeight) / 2 / this.$canvas.height
            }
        }
    }
    computeDrawImageParams(focusPointName) {
        const nextFocusPoint = this.focusPoints[focusPointName]
        const destinationPoint = this.whereToDisplayTheFocusPoint(focusPointName)
        
        const [renderWidth, renderHeight] = this.computeImageRenderScale(nextFocusPoint, destinationPoint)
        const image = this.texture.selectMipmap(renderWidth)
        // const sx = 0
        // const sy = 0
        // const sWidth = image.naturalWidth
        // const sHeight = image.naturalHeight
        const [dx, dy] = this.computeDestinationCoordinates(nextFocusPoint, destinationPoint, renderWidth, renderHeight)
        
        // console.log({image, sx, sy, sWidth, sHeight, dx, dy, renderWidth, renderHeight})
        return [image, dx, dy, renderWidth, renderHeight]
    }
    render() {
        
        // this.ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
        // this.ctx.drawImage(image, dx, dy, renderWidth, renderHeight)
         
        const currentDrawImageParams = [
            this.texture.selectMipmap(this.drawImageParams.current.dWidth, true),
            this.drawImageParams.current.dx,
            this.drawImageParams.current.dy,
            this.drawImageParams.current.dWidth,
            this.drawImageParams.current.dHeight
        ]
        // console.log('currentDrawImageParams', currentDrawImageParams)
        this.ctx.drawImage(...currentDrawImageParams)
    }
    /**
     * returns renderWidth, renderHeight
     */
    computeImageRenderScale(focusPoint, destinationPoint) {
        // Get ratio of canvas around focus point final destination
        const destinationLeftRatio = destinationPoint.x
        const destinationRightRatio = 1 - destinationPoint.x
        const destinationTopRatio = destinationPoint.y
        const destinationBottomRatio = 1 - destinationPoint.y
        
        // console.log('canvas destination ratios', {
        //     destinationLeftRatio, 
        //     destinationRightRatio,
        //     destinationTopRatio,
        //     destinationBottomRatio,
        // })
        // console.log(`At its final position, we\'ll have a ratio of ${destinationLeftRatio} of the canvas width on the left of the focusPoint`)
        
        // compute required pixels number around focusPoint final position
        const requiredPixelsOnLeftOfDestinationPoint = this.$canvas.width * destinationLeftRatio * focusPoint.zoomFactor
        const requiredPixelsOnRightOfDestinationPoint = this.$canvas.width * destinationRightRatio * focusPoint.zoomFactor
        const requiredPixelsOnTopOfDestinationPoint = this.$canvas.height * destinationTopRatio * focusPoint.zoomFactor
        const requiredPixelsOnBottomOfDestinationPoint = this.$canvas.height * destinationBottomRatio * focusPoint.zoomFactor
        
        // console.log('requiredPixelsAroundFinalPosition', {
        //     requiredPixelsOnLeftOfDestinationPoint, 
        //     requiredPixelsOnRightOfDestinationPoint,
        //     requiredPixelsOnTopOfDestinationPoint,
        //     requiredPixelsOnBottomOfDestinationPoint,
        // })
        // console.log(`This destinationLeftRatio of ${destinationLeftRatio} translatates into ${requiredPixelsOnLeftOfDestinationPoint} pixels`)
        
        // Based on this and focusPoint coordinates, determine image render scale
        const focusPointLeftRatio = focusPoint.x
        const focusPointRightRatio = 1 - focusPoint.x
        const focusPointTopRatio = focusPoint.y
        const focusPointBottomRatio = 1 - focusPoint.y
        
        // 400px = 0.5 * image.width
        // 400px / 0.5 = image.width
        
        // portionOfImageWidth = focusPointLeft * requiredImageWidth
        // requiredImageWidth = portionOfImageWidth / focusPointLeft
        
        const requiredImageWidthBasedOnFocusPointLeft = requiredPixelsOnLeftOfDestinationPoint / focusPointLeftRatio
        const requiredImageWidthBasedOnFocusPointRight = requiredPixelsOnRightOfDestinationPoint / focusPointRightRatio
        const requiredImageHeightBasedOnFocusPointTop = requiredPixelsOnTopOfDestinationPoint / focusPointTopRatio
        const requiredImageHeightBasedOnFocusPointBottom = requiredPixelsOnBottomOfDestinationPoint / focusPointBottomRatio
        
        // console.log({
        //     requiredImageWidthBasedOnFocusPointLeft,
        //     requiredImageWidthBasedOnFocusPointRight,
        //     requiredImageHeightBasedOnFocusPointTop,
        //     requiredImageHeightBasedOnFocusPointBottom
        // })
        // console.log(`If focusPoint.x = ${focusPointLeftRatio}, that means ${focusPointLeftRatio * 100}% of the image width must measure ${requiredPixelsOnLeftOfDestinationPoint} pixels, hence 100% of the image width must measure ${requiredImageWidthBasedOnFocusPointLeft} pixels.`)
        
        // retrieve the biggest value for x and y axis
        const requiredWidth = Math.max(requiredImageWidthBasedOnFocusPointLeft, requiredImageWidthBasedOnFocusPointRight)
        const requiredHeight = Math.max(requiredImageHeightBasedOnFocusPointTop, requiredImageHeightBasedOnFocusPointBottom)
        
        // based on the image aspect ratio, determine which is bigger
        const potentialHeight = requiredWidth * (1 / this.imgAspectRatio)
        const potentialWidth = requiredHeight * this.imgAspectRatio
        
        if (potentialWidth > requiredWidth) {
            return [Math.ceil(potentialWidth), requiredHeight]
        } else {
            return [requiredWidth, Math.ceil(potentialHeight)]
        }
        
        // return it
        return [this.$canvas.width, this.$canvas.height]
    }
    
    computeDestinationCoordinates(focusPoint, destinationPoint, renderWidth, renderHeight) {
        // return [0, 0] // debug
        
        const xDiff = Math.ceil( destinationPoint.x * this.$canvas.width - focusPoint.x * renderWidth )
        const yDiff = Math.ceil( destinationPoint.y * this.$canvas.height - focusPoint.y * renderHeight )
        
        
        // console.log({focusPoint, destinationPoint, xDiff, yDiff})
        return [xDiff, yDiff]
    }
    
    triggerTweening() {
        if (this.isTweening) this.tween.kill()
        
        this.isTweening = true
        
        const [_, dx, dy, dWidth, dHeight] = this.drawImageParams.final
        
        this.tween = gsap.to(this.drawImageParams.current, {
            dx, dy, dWidth, dHeight,
            
            delay: 0.1, // TODO check if necessary / adjustable 
            duration: 2,
            ease: CustomEase.create('custom', 'M0,0 C0,0 0,0 0,0 0.5,0 0.25,1 1,1 1,1 1,1 1,1'),
            onComplete: () => {
                this.isTweening = false
                // this.drawImageParams.current = this.drawImageParams.final
            }
        })
        
        this.startLoop()
    }
    startLoop() {
        const loop = () => {
            this.render()
            if (this.isTweening) window.requestAnimationFrame(loop)
        }
        window.requestAnimationFrame(loop)
    }
}